// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMobileAppProblemReportRequestDto
 */
export interface IMobileAppProblemReportRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IMobileAppProblemReportRequestDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppProblemReportRequestDto
     */
    log_details: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppProblemReportRequestDto
     */
    app_version: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppProblemReportRequestDto
     */
    device_info: string;
}

/**
 * Check if a given object implements the IMobileAppProblemReportRequestDto interface.
 */
export function instanceOfIMobileAppProblemReportRequestDto(value: object): value is IMobileAppProblemReportRequestDto {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('log_details' in value) || value['log_details'] === undefined) return false;
    if (!('app_version' in value) || value['app_version'] === undefined) return false;
    if (!('device_info' in value) || value['device_info'] === undefined) return false;
    return true;
}

export function IMobileAppProblemReportRequestDtoFromJSON(json: any): IMobileAppProblemReportRequestDto {
    return IMobileAppProblemReportRequestDtoFromJSONTyped(json, false);
}

export function IMobileAppProblemReportRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMobileAppProblemReportRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'log_details': json['log_details'],
        'app_version': json['app_version'],
        'device_info': json['device_info'],
    };
}

export function IMobileAppProblemReportRequestDtoToJSON(json: any): IMobileAppProblemReportRequestDto {
    return IMobileAppProblemReportRequestDtoToJSONTyped(json, false);
}

export function IMobileAppProblemReportRequestDtoToJSONTyped(value?: IMobileAppProblemReportRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'log_details': value['log_details'],
        'app_version': value['app_version'],
        'device_info': value['device_info'],
    };
}

